import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/api";
import { useSession } from "@/lib/auth";

export interface TaskAccessMember {
  id: string;
  display_name: string | null;
  email: string;
  role: string;
}

export interface TaskAccess {
  role: "system_admin" | "task_manager" | "assignee";
  workspace_id: string;
  user_id: string;
  can_assign: boolean;
  can_manage_managers: boolean;
  can_manage_tasks: boolean;
  can_create: boolean;
  can_edit_own: boolean;
  can_update_assigned: boolean;
  managers: TaskAccessMember[];
  members: TaskAccessMember[];
}

export const TASK_ROLE_LABELS: Record<TaskAccess["role"], string> = {
  system_admin: "システム管理者",
  task_manager: "タスク管理者",
  assignee: "担当者",
};

export function useTaskAccess(workspaceId?: string) {
  const session = useSession();
  const id = workspaceId ?? session?.tenantId;
  return useQuery({
    queryKey: ["task-access", session?.tenantId, id, session?.user.id],
    enabled: !!session && !!id,
    staleTime: 0,
    refetchOnWindowFocus: true,
    queryFn: () => apiGet<TaskAccess>(`/v1/tasks/access?workspace_id=${encodeURIComponent(id!)}`),
  });
}
